import { ServicePage } from "./Service";
export default ServicePage;
